import React, { useEffect, useRef, useState } from "react"

import PropTypes from "prop-types"
import questionIcon from "images/question.svg"

import "./index.less"

import {
  Drawer,
  Button,
  Select,
  Spin,
  Tooltip,
  Radio,
  Popover,
  Modal,
} from "antd"

import { SettingIcon } from "../../../icons/svg/iconSetting"
import { TYPE_BENCHMARK, TYPE_SURVEY } from "../../../utils/constants"
import { ConfirmIcon } from "../../../icons/svg/iconConfirm"
import { verifyFeatureFlag } from "../../../utils/feature-flags"
const { Option } = Select

export function DrawerConfigBenchmark(props) {
  const [visibleDrawer, setVisibleDrawer] = useState(false)
  const [visibleModalConfig, setVisibleModalConfig] = useState(false)
  const [idBenchmarkType, setIdBenchmarkType] = useState(
    props.isSectorDataAvailable ? props.measureConfig.id_benchmark_type : TYPE_BENCHMARK.isGlobal
  )

  const [selectedIdCompanySector, setSelectedIdCompanySector] = useState(props.companySector.id_company_sector);

  useEffect(() => {
    if (props.isLoadingSaveConfig === false) {
      setVisibleModalConfig(false)
      setVisibleDrawer(false)
    }
  }, [props.isLoadingSaveConfig])

  const showDrawer = () => {
    setVisibleDrawer(true)
    if(typeof window.Intercom !== "undefined" &&
      window.self === window.top){
        window.Intercom('update', { hide_default_launcher: true})
      }
  }

  const onClose = () => {
    setVisibleDrawer(false)
    setIdBenchmarkType(props.measureConfig.id_benchmark_type)
    if(typeof window.Intercom !== "undefined" &&
      window.self === window.top){
        Intercom('update', { hide_default_launcher: false });
      }
    
  }

  const handleCancel = () => {
    setVisibleModalConfig(false)
  }

  const handleOk = () => {
    return props.saveConfigBenchmark({
      id_benchmark_type: idBenchmarkType,
      id_measure: props.idMeasure,
      id_company_sector: selectedIdCompanySector
    })
  }

  if (props.isLoading) {
    return (
      <div>
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      </div>
    )
  }

  const renderPopoverBenchmark = () => {
    const content = (
      <div style={{ fontSize: "12px" }}>
        El <strong>benchmark</strong> te permite comparar los <br />
        resultados de tu empresa frente al <strong>promedio</strong> de <br />
        otras empresas que miden con <strong>Mandü.</strong> <br />
        <br />
        <ul style={{ marginLeft: "16px" }}>
          <li>
            <strong>General:</strong> Las cifras reflejarán el promedio de{" "}
            <br /> todas las empresas de todas las industrias <br /> que miden
            con Mandü.
          </li>
          <li>
            <strong>Por industria:</strong> Las cifras reflejarán el <br />{" "}
            promedio de todas las empresas de tu <br /> misma industria que
            miden con Mandü.
          </li>
        </ul>
        El benchmark se <strong>calcula</strong> a nivel de{" "}
        <strong>empresa.</strong> <br />
        <br />
        Si deseas más información puedes ir al artículo <br />
        de nuestro{" "}
        <a
          style={{ color: "#2694FC" }}
          href="https://intercom-help.eu/mandu/es/collections/1400663-mandu-experience"
          target="_blank"
          rel="noreferrer">
          <strong className="help-center">help center</strong>
        </a>
        .
      </div>
    )
    return (
      <Popover
        placement="bottomRight"
        content={content}
        title="Benchmark Mandü">
        <Button type="link" style={{ padding: "0 8px", lineHeight: "8px" }}>
          <img src={questionIcon} alt="question" />
        </Button>
      </Popover>
    )
  }

  const onChangeOptionBenchmark = (value) => {
    setIdBenchmarkType(value)
  }

  const renderSelectCompanySector = () => {
    const  typeBenchmark=props.isSectorDataAvailable ? props.measureConfig.id_benchmark_type : TYPE_BENCHMARK.isGlobal;
    const contentSelect= typeBenchmark == TYPE_BENCHMARK.isGlobal ? props.companySectors[0].id_company_sector : props.companySector.id_company_sector
    console.log('contentSelect', typeBenchmark,TYPE_BENCHMARK.isGlobal, contentSelect)
    if(verifyFeatureFlag('select-company-sector-benchmark')){
      return (
        ( idBenchmarkType === TYPE_BENCHMARK.isIndustry) && (
          <div className="DrawerConfigBenchmark--container-select">
            <div className="DrawerConfigBenchmark--container-select-wrapper">
              <label className={`${idBenchmarkType === TYPE_BENCHMARK.isGlobal ? 'labelGlobal' : ''}`}>Seleccionar industria:</label>
              <Select
                defaultValue={contentSelect}
                onChange={(value) => setSelectedIdCompanySector(value)}
                placeholder="Seleccionar industria"
                style={{flex: 1}} >
                {
                  props.companySectors.map((companySector) => (
                    <Option key={companySector.id_company_sector} value={companySector.id_company_sector}>
                      { companySector.name }
                    </Option>
                  ))
                }
              </Select>
            </div>
          </div>
        )
      )
    }
  }

  const renderOptionsBenchmark = () => {

    return (
      <div className="DrawerConfigBenchmark--container-options">
        <span>
          Selecciona el tipo de <strong>benchmark</strong> para comparar con tus
          resultados:
        </span>
        <div className="DrawerConfigBenchmark--container-wrapper">
          <div className="DrawerConfigBenchmark--container-options-container">
            <div className="DrawerConfigBenchmark--container-options-container-radioGroup">
              <Radio.Group
                onChange={(e) => {
                  onChangeOptionBenchmark(e.target.value)
                }}
                value={idBenchmarkType}>
                <Radio value={TYPE_BENCHMARK.isGlobal}>General</Radio>
                  <Radio
                    style={{ marginLeft: "32px" }}
                    value={TYPE_BENCHMARK.isIndustry}>
                    Por industria
                  </Radio>

              </Radio.Group>
            </div>

            {renderPopoverBenchmark()}
          </div>
          {renderSelectCompanySector()}
        </div>
      </div>
    )
  }

  const renderPeriodsBenchmark = () => {
    return (
      <div className="DrawerConfigBenchmark--container-periods">
        <span>
          Selecciona el periodo de la información de <strong>benchmark:</strong>
        </span>
        <Select defaultValue="lucy" style={{ width: 120, marginTop: 8 }}>
          <Option value="jack">Jack</Option>
          <Option value="lucy">Lucy</Option>
          <Option value="disabled" disabled>
            Disabled
          </Option>
          <Option value="Yiminghe">yiminghe</Option>
        </Select>
      </div>
    )
  }

  const renderFooter = () => {
    if (idBenchmarkType === props.measureConfig.id_benchmark_type && selectedIdCompanySector === props.companySector.id_company_sector) {
      return null
    }
    return (
      <div
        style={{
          textAlign: "right",
        }}>
        <Button onClick={() => onClose()} style={{ marginRight: 8 }}>
          Cancelar
        </Button>
        <Button onClick={() => openModalConfirm()} type="primary">
          Guardar
        </Button>
      </div>
    )
  }

  const openModalConfirm = () => {
    setVisibleModalConfig(true)
    if(typeof window.Intercom !== "undefined" &&
      window.self === window.top){
        Intercom('update', { hide_default_launcher: false });
      }
  }

  return (
    <>
      {props.measureGeneral.id_survey_type === TYPE_SURVEY.climate.idSurveyType ? <Tooltip title="Configurar medición">
        <Button
          className="reportAdmin__Header--options--config"
          icon={<SettingIcon />}
          onClick={() => showDrawer()}
        />
      </Tooltip> : <></>}
      <Drawer
        title="Configurar medición"
        width={550}
        onClose={() => onClose()}
        visible={visibleDrawer}
        bodyStyle={{ padding: "0" }}
        footer={renderFooter()}>
        <div className="DrawerConfigBenchmark--container">
          {renderOptionsBenchmark()}
        </div>
      </Drawer>
      <Modal
        overlayClassName="ModalConfirmConfigBenchmark"
        visible={visibleModalConfig}
        width={540}
        closable={false}
        onOk={() => handleCancel()}
        onCancel={() => handleOk()}
        footer={[
          <Button
            key="back"
            loading={props.isLoadingSaveConfig}
            onClick={() => handleCancel()}>
            Cancelar
          </Button>,
          <Button
            loading={props.isLoadingSaveConfig}
            key="submit"
            type="primary"
            onClick={() => handleOk()}>
            Aceptar
          </Button>,
        ]}>
        <div className="ModalConfirmConfigBenchmark--content">
          <div className="ModalConfirmConfigBenchmark--content-icon">
            <ConfirmIcon />
          </div>
          <div className="ModalConfirmConfigBenchmark--content-title">
            ¿Estás seguro de que deseas guardar los cambios en la configuración?
          </div>
          <div className="ModalConfirmConfigBenchmark--content-message">
            Los reportes de tu medición reflejarán los cambios realizados. Todos
            los usuarios de la empresa que tengan acceso a la medición, podrán
            visualizar los cambios al actualizar la página.
          </div>
        </div>
      </Modal>
    </>
  )
}

DrawerConfigBenchmark.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureGeneral: PropTypes.object,
  measureConfig: PropTypes.object,
  isLoading: PropTypes.bool,
  isSectorDataAvailable: PropTypes.bool,
  saveConfigBenchmark: PropTypes.func,
  isLoadingSaveConfig: PropTypes.bool,
}
export default DrawerConfigBenchmark
